import style from './../Report.module.scss';
import ErrorsByTimeGraph from './ErrorsByTimeGraph/ErrorsByTimeGraph';
import ErrorsByType from './ErrorsByType/ErrorsByType';
import ErrorsByPlatform from './ErrorsByPlatform/ErrorsByPlatform';
import ReportTypeStructure from '../ReportTypeStructure';
import moment from 'moment';

const ErrorsReport = ({report, isStandalone}) => {
    const {data} = report;
    const {clinic, errors} = data;

    const getHeader = () => {
        return (
            <div className='d-flex'>
                {clinic && clinic.logo && <img src={clinic.logo} alt='logo' className={style.clinicLogo} />}
                <div>
                    <h1>{clinic && clinic.name ? clinic.name : 'Unknown clinic'}: Errors Report</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <h5>Errors Overview</h5>

                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByType data={errors.by_type} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByPlatform data={errors.by_platform} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')}>
                            <ErrorsByTimeGraph data={errors.by_time.data} tick={errors.by_time.tick} />
                        </div>
                    </div>

                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={getHeader()} content={getContent()} />
    )
}

export default ErrorsReport;